<template>
  <div class='technologies-widget'>
    <TableByColumn
      :categories='tableCategories'
      :items='items'
      :columnTitles='columnTitles'
      >
      <component
        slot="column-cell"
        slot-scope="columnCell"
        class="table-column-cell"
        :is="tableColumnCellComponentsHash[columnCell.category.field] || tableColumnCellComponentsHash.default"
        :item="columnCell.item"
        :category="columnCell.category"
        @click='openLink(columnCell.item)'
      />
    </TableByColumn>
  </div>
</template>

<script>
import TableByColumn from '@/components/TableByColumn/TableByColumn.vue';
import TableDefaultCell from '@/components/TableByColumn/TableDefaultCell.vue';
import ExploitableTableCell from '@/components/tableCells/TechnologiesDashboardTableCells/ExploitableTableCell.vue';
import AmountOfAssetsTableCell from '@/components/tableCells/TechnologiesDashboardTableCells/AmountOfAssetsTableCell.vue';
import TechnologyNameTableCell from '@/components/tableCells/TechnologiesDashboardTableCells/TechnologyNameTableCell.vue';
import { views } from '@/router/constants';
import { specialTechNames } from '@/constants/technologies';

export default {
  name: 'TechnologiesWidget',
  components: {
    TableByColumn,
  },
  props: {
    columnTitles: {
      required: false,
      type: Array,
      default: () => [],
    },
    tableCategories: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
  },
  methods: {
    async openLink(item) {
      await this.$router.push({ name: views.INVENTORY, hash: '#technologies', params: { search: this.getFormattedTechName(item).toLowerCase() } });
    },
    getFormattedTechName(item) {
      const allTechNameParts = item.technology.split('/');
      return Object.keys(specialTechNames).includes(allTechNameParts[0].toLowerCase()) ? specialTechNames[allTechNameParts[0].toLowerCase()] : allTechNameParts[0];
    },
  },
  computed: {
    tableColumnCellComponentsHash() {
      return {
        technology: TechnologyNameTableCell,
        amount: AmountOfAssetsTableCell,
        exploitable: ExploitableTableCell,
        default: TableDefaultCell,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.technologies-widget {
  border-radius: $radius-md;
  background-color: var(--bg-secondary);
}
</style>

<style lang="scss">
@import '~@/assets/styles/design-system';

.technologies-widget {
  .table-column__values {
    margin-top: 2%;
    height: 100%;

    &:hover {
      cursor: pointer;
    }
  }
}
</style>
